// extracted by mini-css-extract-plugin
module.exports = {"container":"PageDescription_container__owGMr"};